import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/no-anonymous-default-export */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useThemeUI } from 'theme-ui';
import { cf2imgix } from '../../elements/imgix-img';
import Card from '../../elements/trustyle-card';
import { Palette, RichText } from '@uswitch/ev-core/react';
import { useEntity, useMeta } from '@uswitch/ev-utils/context/selectors';
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import { path } from '@uswitch/ev-utils/obj';
import getSizes from '../../../utils/get-sizes';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var DEFAULT_CONTAINER_MAX_WIDTH = 1200;
export var cardStylePath = function cardStylePath(field, variant) {
  return getVariantPath({
    atomicType: 'compounds',
    componentId: 'card',
    variantName: variant,
    field: field
  });
};
export var BlankCard = function BlankCard() {
  return _jsx("div", {
    sx: {
      display: 'flex',
      width: function width(_ref) {
        var _ref$compounds = _ref.compounds,
            compounds = _ref$compounds === void 0 ? {} : _ref$compounds;
        return compounds.card ? compounds.card.width : 0;
      }
    }
  });
};

var CardWithConnectedImage = function CardWithConnectedImage(_ref2) {
  var entity = _ref2.entity,
      cardProps = _ref2.cardProps;

  var _useEntity = useEntity(entity),
      description = _useEntity.description,
      date = _useEntity.date,
      file = _useEntity.file;

  var cardMeta = useMeta(['card']);

  var props = _objectSpread({
    critical: false,
    imgSrc: cf2imgix(file === null || file === void 0 ? void 0 : file.url),
    imgAlt: description,
    superScript: date
  }, cardProps);

  if (cardMeta !== null && cardMeta !== void 0 && cardMeta.clickable && props.linkHref) {
    return _jsx("div", {
      onClick: function onClick() {
        return window.location.href = props.linkHref;
      },
      sx: {
        cursor: 'pointer',
        variant: cardStylePath('clickWrapper')
      },
      role: "link",
      tabIndex: 0,
      children: _jsx(Card, _objectSpread({}, props))
    });
  }

  return _jsx(Card, _objectSpread({}, props));
}; // We are connecting the nested image asset to the card data


var WrappedCard = function WrappedCard(props) {
  var _theme$compounds, _theme$compounds$card, _theme$compounds$card2, _props$headerChildren, _props$headerChildren2, _cardMeta$variants, _cardMeta$variants$va, _guide$sys, _guide$sys2, _cardMeta$variants2, _cardMeta$variants2$v;

  var entity = props.entity,
      variant = props.variant,
      showDate = props.showDate;
  var theme = useThemeUI().theme;
  var cardMeta = useMeta(['card'], {});
  var customVariant = path(['variants', variant, 'custom'], cardMeta, false);
  var guide = useEntity(entity);
  var cardTheme = ((_theme$compounds = theme.compounds) === null || _theme$compounds === void 0 ? void 0 : (_theme$compounds$card = _theme$compounds.card) === null || _theme$compounds$card === void 0 ? void 0 : (_theme$compounds$card2 = _theme$compounds$card.variants) === null || _theme$compounds$card2 === void 0 ? void 0 : _theme$compounds$card2[props.variant]) || {};
  var mappedProps = {
    imgSizes: cardTheme === null || cardTheme === void 0 ? void 0 : cardTheme.imgSizes
  };
  if (props.headerIconSettings) mappedProps.headerChildren = props.headerIconSettings;
  if (props.headerChildren) mappedProps.headerChildren = RichText({
    content: (_props$headerChildren = props.headerChildren) === null || _props$headerChildren === void 0 ? void 0 : _props$headerChildren.content
  });
  if (props.contentChildren) mappedProps.contentChildren = RichText({
    content: (_props$headerChildren2 = props.headerChildren) === null || _props$headerChildren2 === void 0 ? void 0 : _props$headerChildren2.content
  });
  if (cardTheme !== null && cardTheme !== void 0 && cardTheme.imageSize) mappedProps.imageSize = cardTheme === null || cardTheme === void 0 ? void 0 : cardTheme.imageSize;
  var metaImageProps = (cardMeta === null || cardMeta === void 0 ? void 0 : (_cardMeta$variants = cardMeta.variants) === null || _cardMeta$variants === void 0 ? void 0 : (_cardMeta$variants$va = _cardMeta$variants[variant]) === null || _cardMeta$variants$va === void 0 ? void 0 : _cardMeta$variants$va.imageProps) || {};

  var imageProps = _objectSpread(_objectSpread({}, metaImageProps), {}, {
    imgixParams: _objectSpread({
      auto: 'format,compress'
    }, metaImageProps.imgixParams),
    sizes: getSizes(['100vw', '100vw', path(['layout', 'flex-grid', 'container', 'maxWidth'], theme, DEFAULT_CONTAINER_MAX_WIDTH)], theme.breakpoints)
  });

  var date = new Date(props.customDate || ((_guide$sys = guide.sys) === null || _guide$sys === void 0 ? void 0 : _guide$sys.updatedAt) || ((_guide$sys2 = guide.sys) === null || _guide$sys2 === void 0 ? void 0 : _guide$sys2.createdAt));
  var description = customVariant && guide.sys && guide.sys.trimmedContent;
  var linkIconValue = (cardMeta === null || cardMeta === void 0 ? void 0 : (_cardMeta$variants2 = cardMeta.variants) === null || _cardMeta$variants2 === void 0 ? void 0 : (_cardMeta$variants2$v = _cardMeta$variants2[variant]) === null || _cardMeta$variants2$v === void 0 ? void 0 : _cardMeta$variants2$v.linkIcon) || null;
  return props.image ? _jsx(CardWithConnectedImage, {
    entity: props.image,
    cardProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), mappedProps), {}, {
      linkIcon: linkIconValue,
      imageProps: imageProps
    }, customVariant && guide.sys && {
      description: description
    }), showDate && {
      date: date
    })
  }) : _jsx(Card, _objectSpread(_objectSpread({}, props), showDate && {
    date: date
  }));
};

export default (function (props) {
  return _jsx(Palette, _objectSpread({
    px: {
      backgroundColor: 'featureColor',
      p: {
        color: 'textColor'
      },
      'div > h3, div > h3 > a': {
        color: 'accentTextColor'
      }
    },
    as: WrappedCard
  }, props));
});
//# sourceMappingURL=index.js.map